import React from 'react';
import '../style.css'

const Welcome = () => {
  return (
      <div className="welcome_business">
        <div className='welcome_business_wrapper'>
          <h1 className="heading_large">Time to fight COVID-19</h1>
          <p>Use our special application to track COVID-19 risk in your company</p>
          <div className="primary_btn_black">Start caring now</div>
        </div>
      </div>
  );
};

export default Welcome;
